import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Typography } from '@material-ui/core';

const ExpandableComponent = ({ icon, mainHeading, blueHeading, children, expanded }) => {
  const [isExpand, setIsExpand] = React.useState(expanded);

  const handleToggle = () => {
    setIsExpand(!isExpand);
  };

  return (
    <div className="expandable-component-wrapper">
      <div className="top-wrapper" onClick={handleToggle}>
        <div className="tag-icon-wrapper">
          <img src={icon} />
        </div>
        <Typography className="heading medium-font" component="h5" >{mainHeading}</Typography>
        <IconButton aria-label="toggle-expand" size="small" onClick={handleToggle}>
          {isExpand ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
        </IconButton>
      </div>
      <Collapse in={isExpand}>
        <hr />
        <div className="body-wrapper">
        {blueHeading && <Typography className="blue-text small-font" variant="body1">
          {blueHeading}
        </Typography>}
        <div className="body-text small-font">
          {children}
        </div>
        </div>
      </Collapse>
    </div>
  );
};

ExpandableComponent.propTypes = {
  expanded: PropTypes.bool,
  icon: PropTypes.string,
  mainHeading: PropTypes.string,
  blueHeading: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ExpandableComponent;
